// extracted by mini-css-extract-plugin
export default {"expressCheckoutSection":"bv-z","expressButtonContainerWithPayPal":"cv-z","expressButton":"dv-z","or":"ev-z"};